import { TransactionStatus } from './transaction';

export const API_SIGNATURE_KEY_HEADER = 'Authorization-Signature';

export interface ISetCheckpointReq {
  checkpoint: string;
}

export interface IGetCheckpointResp {
  checkpoint: string;
}

export interface IExistMSafeResp {
  exist: boolean;
}

export interface IProcessTransactionRequest {
  digest: string;
  status: TransactionStatus;
  executedAt: Date;
}

export interface IProcessCoinTransferRequest {
  digest: string;
  msafeAddress: string;
  coinType: string;
  amount: string;
  sender: string;
  receiver: string;
  executedAt: Date;
}

export interface IProcessObjectTransferRequest {
  digest: string;
  msafeAddress: string;
  objectId: string;
  objectVersion: string;
  objectType: string;
  sender: string;
  receiver: string;
  executedAt: Date;
}
